
import { useEffect } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConvexProvider, ConvexReactClient } from "convex/react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Gleap from "gleap";
import { DeviceProvider } from "./contexts/DeviceContext";
import { config } from "./config/environment";
import Index from "./pages/Index";
import AppDetail from "./pages/AppDetail";
import Updates from "./pages/Updates";
import General from "./pages/General";
import Requests from "./pages/Requests";
import RequestedList from "./pages/requests/RequestedList";


import Settings from "./pages/Settings";
import UserLevel from "./pages/settings/UserLevel";
import Apps from "./pages/settings/Apps";
import Browser from "./pages/settings/Browser";
import GeneralRestrictions from "./pages/settings/GeneralRestrictions";
import NotFound from "./pages/NotFound";
import NoDeviceError from "./pages/NoDeviceError";

import BottomNavigation from "./components/BottomNavigation";

const queryClient = new QueryClient();

// Convex client with better error handling
const convex = new ConvexReactClient(config.convex.url, { verbose: true });

// Layout component that provides device context after route matching
const DeviceLayout = () => (
  <DeviceProvider>
    <div className="relative">
      <Routes>
        <Route path="/:deviceId" element={<Index />} />
        <Route path="/:deviceId/app/:appId" element={<AppDetail />} />
        <Route path="/:deviceId/updates" element={<Updates />} />
        <Route path="/:deviceId/general" element={<General />} />
        <Route path="/:deviceId/requests" element={<Requests />} />
        <Route path="/:deviceId/requests/list" element={<RequestedList />} />
        
        
        <Route path="/:deviceId/settings" element={<Settings />} />
        <Route path="/:deviceId/settings/level" element={<UserLevel />} />
        <Route path="/:deviceId/settings/apps" element={<Apps />} />
        <Route path="/:deviceId/settings/browser" element={<Browser />} />
        <Route path="/:deviceId/settings/general" element={<GeneralRestrictions />} />
        <Route path="/" element={<Index />} />
        
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <BottomNavigation />
    </div>
  </DeviceProvider>
);

const App = () => {
  useEffect(() => {
    Gleap.initialize('w9gN3dxdGO56Kh2vzUjT4KwJ4nGiiX70');
    Gleap.showFeedbackButton(false);
    
    Gleap.hideAiChatbar();
  }, []);

  return (
    <ConvexProvider client={convex}>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <DeviceLayout />
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </ConvexProvider>
  );
};

export default App;
